/**
 * Convert a base64-encoded payload (no `data:` prefix) into a Blob with the
 * given MIME type. Used by the image-upload services to translate the
 * in-memory cropper output into raw bytes for multipart form posts so the
 * server's magic-byte sniff can validate the image without base64-decoding.
 */
export const base64ToBlob = (dataBase64: string, mimeType: string): Blob => {
    const binary = atob(dataBase64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i += 1) {
        bytes[i] = binary.charCodeAt(i);
    }
    return new Blob([bytes], { type: mimeType });
};
